import { render, staticRenderFns } from "./approve-opinion.vue?vue&type=template&id=6586f4bb&scoped=true&"
import script from "./approve-opinion.vue?vue&type=script&lang=ts&"
export * from "./approve-opinion.vue?vue&type=script&lang=ts&"
import style0 from "./approve-opinion.vue?vue&type=style&index=0&id=6586f4bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586f4bb",
  null
  
)

export default component.exports